module.exports = __webpack_public_path__ + "static/media/document.f74dbfe9.svg";